module.exports = __webpack_public_path__ + "072ceaa2a91d2da85763a3d85d762d68.pdf";